const getters = {
  menuType: state => state.menu.menuType,
  headerBg: state => state.menu.headerBg,
  MenuImg: state => state.menu.MenuImg,
  MenuTheme: state => state.menu.MenuTheme,
  headerColor: state => state.menu.headerColor,
  headerBorderColor: state => state.menu.headerBorderColor,
  headerBorderTop: state => state.menu.headerBorderTop,
  closeBg: state => state.menu.closeBg,
  borderTopLeft: state => state.menu.borderTopLeft,
  leftBoxColor: state => state.menu.leftBoxColor,
  leftBoxShow: state => state.menu.leftBoxShow,
  nowPath: state => state.menu.nowPath,
  totalOrPart: state => state.menu.totalOrPart,
  menuData: state => state.menu.menuData,
  menuItem: state => state.menu.menuItem,

  userInfo: state => state.userInfo.userInfo,
  basicInfo:state =>state.flow.basicInfo,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js